<template>
    <v-container>
        <template v-for="(item, index) in breadCrumbs">
            <v-breadcrumbs-item
                    :to="{name: item.to}"
                    :disabled="item.disabled"
                    :exact="true"
                    class="breadcrumb-link"
                    @click="returnSubmenu(item)"
            >
                {{item.title}}
            </v-breadcrumbs-item>
            <v-breadcrumbs-divider  v-if="index < breadCrumbs.length -1" >
                <v-icon class="separator" icon="mdi-chevron-right orange"></v-icon>
            </v-breadcrumbs-divider>
        </template>
    </v-container>
</template>

<script>
import {onBeforeMount, ref, watch} from "vue";
import {useRoute, useRouter} from "vue-router";
import store from "@/store";

export default {
    name: "BreadCrumb",
    setup(){
        const router = useRouter()
        const route = useRoute()

        let breadCrumbs = ref([])

        onBeforeMount(async () => {
            await router.isReady()
            breadCrumbs.value = fillBreadCrum()
        })

        watch(route, () => {
            breadCrumbs.value = fillBreadCrum()
        })

        function returnSubmenu(submenu){
            if (submenu.children){
                store.commit('setChildrenMenu', submenu);
                localStorage.setItem('children_menu', JSON.stringify(submenu))
            }else{
                store.commit('setChildrenMenu', false);
                localStorage.setItem('children_menu', JSON.stringify(false))
            }
        }

        const fillBreadCrum = () => {
            if (typeof route.meta.breadCrumb === "function") {
                return route.meta.breadCrumb(route);
            }
            return route.meta.breadCrumb;
        }

        return{
            breadCrumbs,
            returnSubmenu
        }
    }
}
</script>

<style lang="scss">
.separator{
    color: $primary-color-1;
}

.v-breadcrumbs-item--link{
    text-decoration: none;
    color: $gray-medium-bold !important;

    &:hover{
        font-weight: bold;
        text-decoration: none !important;
        color: $primary-color-1 !important;
    }


}
</style>